module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [(_vm.canAccess('series-view-any')) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Series Master")]), _vm._v(" "), _c('span', {
    staticClass: "pull-center"
  }, [(_vm.canAccess('series-update')) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editModal(_vm.series)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Member Prefix")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.memberPrefix))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Member Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.memberSeries))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch Code Inclusion")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.memberIncludeBranchCode == 'true'),
      expression: "series.memberIncludeBranchCode == 'true'"
    }]
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.memberIncludeBranchCode == 'false'),
      expression: "series.memberIncludeBranchCode == 'false'"
    }]
  }, [_c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("No")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Employee/Agent Prefix")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.agentPrefix))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Employee/Agent Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.agentSeries))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch Code Inclusion")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.agentIncludeBranchCode == 'true'),
      expression: "series.agentIncludeBranchCode == 'true'"
    }]
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.agentIncludeBranchCode == 'false'),
      expression: "series.agentIncludeBranchCode == 'false'"
    }]
  }, [_c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("No")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Application Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.applicationSeries))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch Code Inclusion")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.applicationIncludeBranchCode == 'true'),
      expression: "series.applicationIncludeBranchCode == 'true'"
    }]
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.series.applicationIncludeBranchCode == 'false'),
      expression: "series.applicationIncludeBranchCode == 'false'"
    }]
  }, [_c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("No")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Branch Prefix")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.branchPrefix))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Branch Series")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.series.branchSeries))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_vm._v("\r\n          List of Series\r\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateSeries()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Member Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberPrefix),
      expression: "form.memberPrefix"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('memberPrefix'),
    },
    attrs: {
      "type": "text",
      "name": "memberPrefix"
    },
    domProps: {
      "value": (_vm.form.memberPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberPrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberSeries),
      expression: "form.memberSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('memberSeries'),
    },
    attrs: {
      "type": "text",
      "name": "memberSeries"
    },
    domProps: {
      "value": (_vm.form.memberSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberSeries"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Branch Code Inclusion")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberIncludeBranchCode),
      expression: "form.memberIncludeBranchCode"
    }],
    staticClass: "form-check-input",
    class: {
      'is-invalid': _vm.form.errors.has('memberIncludeBranchCode'),
    },
    attrs: {
      "value": "true",
      "id": "customRadio1",
      "type": "radio",
      "name": "memberIncludeBranchCode"
    },
    domProps: {
      "checked": _vm._q(_vm.form.memberIncludeBranchCode, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "memberIncludeBranchCode", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "customRadio1"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberIncludeBranchCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberIncludeBranchCode),
      expression: "form.memberIncludeBranchCode"
    }],
    staticClass: "form-check-input",
    class: {
      'is-invalid': _vm.form.errors.has('memberIncludeBranchCode'),
    },
    attrs: {
      "value": "false",
      "id": "customRadio2",
      "type": "radio",
      "name": "memberIncludeBranchCode"
    },
    domProps: {
      "checked": _vm._q(_vm.form.memberIncludeBranchCode, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "memberIncludeBranchCode", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "customRadio2"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberIncludeBranchCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Employee Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentPrefix),
      expression: "form.agentPrefix"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('agentPrefix')
    },
    attrs: {
      "type": "text",
      "name": "agentPrefix"
    },
    domProps: {
      "value": (_vm.form.agentPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "agentPrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentSeries),
      expression: "form.agentSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('agentSeries'),
    },
    attrs: {
      "type": "text",
      "name": "agentSeries"
    },
    domProps: {
      "value": (_vm.form.agentSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "agentSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentSeries"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Branch Code Inclusion")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentIncludeBranchCode),
      expression: "form.agentIncludeBranchCode"
    }],
    staticClass: "form-check-input",
    class: {
      'is-invalid': _vm.form.errors.has('agentIncludeBranchCode'),
    },
    attrs: {
      "value": "true",
      "id": "customRadio5",
      "type": "radio",
      "name": "agentIncludeBranchCode"
    },
    domProps: {
      "checked": _vm._q(_vm.form.agentIncludeBranchCode, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "agentIncludeBranchCode", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "customRadio5"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentIncludeBranchCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.agentIncludeBranchCode),
      expression: "form.agentIncludeBranchCode"
    }],
    staticClass: "form-check-input",
    class: {
      'is-invalid': _vm.form.errors.has('agentIncludeBranchCode'),
    },
    attrs: {
      "value": "false",
      "id": "customRadio6",
      "type": "radio",
      "name": "agentIncludeBranchCode"
    },
    domProps: {
      "checked": _vm._q(_vm.form.agentIncludeBranchCode, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "agentIncludeBranchCode", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "customRadio6"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agentIncludeBranchCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Application Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.applicationSeries),
      expression: "form.applicationSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('applicationSeries'),
    },
    attrs: {
      "type": "text",
      "name": "applicationSeries"
    },
    domProps: {
      "value": (_vm.form.applicationSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "applicationSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "applicationSeries"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Branch Code Inclusion")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.applicationIncludeBranchCode),
      expression: "form.applicationIncludeBranchCode"
    }],
    staticClass: "form-check-input",
    class: {
      'is-invalid': _vm.form.errors.has('applicationIncludeBranchCode'),
    },
    attrs: {
      "value": "true",
      "id": "customRadio9",
      "type": "radio",
      "name": "applicationIncludeBranchCode"
    },
    domProps: {
      "checked": _vm._q(_vm.form.applicationIncludeBranchCode, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "applicationIncludeBranchCode", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "customRadio9"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "applicationIncludeBranchCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.applicationIncludeBranchCode),
      expression: "form.applicationIncludeBranchCode"
    }],
    staticClass: "form-check-input",
    class: {
      'is-invalid': _vm.form.errors.has('applicationIncludeBranchCode'),
    },
    attrs: {
      "value": "false",
      "id": "customRadio10",
      "type": "radio",
      "name": "applicationIncludeBranchCode"
    },
    domProps: {
      "checked": _vm._q(_vm.form.applicationIncludeBranchCode, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "applicationIncludeBranchCode", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "customRadio10"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "applicationIncludeBranchCode"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', [_vm._v("Branch Series Update")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branchPrefix),
      expression: "form.branchPrefix"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branchPrefix'),
    },
    attrs: {
      "type": "text",
      "name": "branchPrefix"
    },
    domProps: {
      "value": (_vm.form.branchPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "branchPrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branchPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branchSeries),
      expression: "form.branchSeries"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branchSeries'),
    },
    attrs: {
      "type": "text",
      "name": "branchSeries"
    },
    domProps: {
      "value": (_vm.form.branchSeries)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "branchSeries", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branchSeries"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(13)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Member Series Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Employee/Agent Series Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Application Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Branch Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Master Series Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member Prefix "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Employee Prefix "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Agent Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Application Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Prefix "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch Series "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("UPDATE")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("CANCEL")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e6ad7bf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/master/SeriesMaster.vue
// module id = 826
// module chunks = 0